import * as React from 'react';
import {
  Create,
  SimpleForm,
} from 'react-admin';
import ConsumablesCalculatorAssayForm from './ConsumablesCalculatorAssayForm';
import FormToolbar from '../shared/FormToolbar';

const ConsumablesCalculatorAssayEdit = props => (
  <Create {...props}>
    <SimpleForm
      toolbar={<FormToolbar />}
      redirect="list"
    >
      <ConsumablesCalculatorAssayForm {...props} />
    </SimpleForm>
  </Create>
);

export default ConsumablesCalculatorAssayEdit;
